// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconArrowDownSmall = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 25', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.47 9.47a.75.75 0 011.06 0l3.22 3.219 3.22-3.22a.75.75 0 011.06 1.061l-3.573 3.573a1 1 0 01-1.414 0L7.47 10.53a.75.75 0 010-1.06z"
      fill="currentColor"
    />
  );
export default SvgIconArrowDownSmall;
